import { MatDialogConfig, MatDialogRef } from '@angular/material';
import { DialogData, DialogResult } from 'src/app/global/models/dialog/dialog-data';
import { DialogDataThree, DialogDataThreeResult } from 'src/app/global/models/dialog/dialog-data-three';
import { PdfDialogDataResult } from 'src/app/global/models/dialog/pdf-dialog-data';
import { ResumeHiringDialogResult } from 'src/app/global/models/dialog/resume-hiring-data';
import { CiValidationComponent } from 'src/app/main/dialogs/ci-validation/ci-validation.component';
import { CiViewerComponent } from 'src/app/main/dialogs/ci-viewer/ci-viewer.component';
import { DialogThreeInfoComponent } from 'src/app/main/dialogs/dialog-three-info/dialog-three-info.component';
import { DialogErrorComponent } from 'src/app/main/dialogs/dialog-error/dialog-error.component';
import { OneActionComponent } from 'src/app/main/dialogs/one-action/one-action.component';
import { PdfViewerComponent } from 'src/app/main/dialogs/pdf-viewer/pdf-viewer.component';
import { ResumeHiringComponent } from 'src/app/main/dialogs/resume-hiring/resume-hiring.component';
import { SegundoPlanoComponent } from 'src/app/main/dialogs/segundo-plano/segundo-plano.component';
import { TwoActionsComponent } from 'src/app/main/dialogs/two-actions/two-actions.component';
import { ValoresMCCComponent } from 'src/app/main/dialogs/valores-mcc/valores-mcc.component';
import { Product } from '../components/shopping-cart/product';
import { DialogRoundedComponent } from 'src/app/main/dialogs/dialog-rounded/dialog-rounded.component';

export abstract class DialogService {


    abstract openOneActionDialog(config: MatDialogConfig<DialogData>): MatDialogRef<OneActionComponent, DialogResult>;

    abstract openDialogError(config: MatDialogConfig<DialogData>): MatDialogRef<DialogErrorComponent, DialogResult>;

    abstract openTwoActionsDialog(config: MatDialogConfig<DialogData>): MatDialogRef<TwoActionsComponent, DialogResult>;

    abstract openIntentoDialog(): MatDialogRef<OneActionComponent, DialogResult>;

    abstract openSolicitudVacia(): MatDialogRef<OneActionComponent, DialogResult>;

    abstract openCambioProductoRechazado(producto: string): MatDialogRef<OneActionComponent, DialogResult>;

    abstract openContratacionNoIniciada(): MatDialogRef<OneActionComponent, DialogResult>;

    abstract openPdfViewer(url: string): MatDialogRef<PdfViewerComponent, PdfDialogDataResult>;

    abstract openTbkClientDialog(): MatDialogRef<OneActionComponent, DialogResult>;

    abstract openRequestInProgressDialog(ss: string): MatDialogRef<OneActionComponent, DialogResult>;

    abstract openInvalidSerieOfRutFirstAttemptDialog(): MatDialogRef<OneActionComponent, DialogResult>;
    abstract openInvalidSerieOfRutSecondAttemptDialog(): MatDialogRef<OneActionComponent, DialogResult>;

    abstract openAccountBloquedDialog(): MatDialogRef<OneActionComponent, DialogResult>;

    abstract openResumeHiringDialog(): MatDialogRef<ResumeHiringComponent, ResumeHiringDialogResult>;
    abstract openWithoutHiringDialog(): MatDialogRef<OneActionComponent, DialogResult>;

    abstract openCiViewerDialog(): MatDialogRef<CiViewerComponent, DialogResult>;
    abstract openCiValidationDialog(rut: string,opts?:{preventDefaultSubmit?:boolean}): MatDialogRef<CiValidationComponent, DialogResult>;

    abstract openCedulaNoVigenteDialog(): MatDialogRef<OneActionComponent, DialogResult>;

    abstract openErrorDialog(title: string, message: string);

    abstract openDeleteProductDialog(product: Product): MatDialogRef<TwoActionsComponent, DialogResult>;

    abstract openChangeProductDialog(product: Product): MatDialogRef<TwoActionsComponent, DialogResult>;

    abstract openRubroProhibidoNN(): MatDialogRef<OneActionComponent, DialogResult>;

    abstract openRubroProhibido11(): MatDialogRef<OneActionComponent, DialogResult>;

    abstract openConfirmarFechaDefecto(fecha: string): MatDialogRef<TwoActionsComponent, DialogResult>;
    abstract refreshTokenDialog();
    abstract openProductoNoDisponible(producto: string): MatDialogRef<OneActionComponent, DialogResult>;
    abstract openRutPerteneceAEmpresaDialog(): MatDialogRef<TwoActionsComponent, DialogResult>;

    abstract openMaximoProductos(): MatDialogRef<OneActionComponent, DialogResult>;
    abstract openActividadSinCategoria(): MatDialogRef<OneActionComponent, DialogResult>;
    abstract openRutPerteneceAPropiaDialog(): MatDialogRef<TwoActionsComponent, DialogResult>;

    abstract openRetomaPedido(producto: string): MatDialogRef<TwoActionsComponent, DialogResult>;
    abstract openProcesoSegundoPlano(): MatDialogRef<OneActionComponent, DialogResult>;

    abstract openDialogThreeInfoComponent(dialogDataThree: DialogDataThree): MatDialogRef<DialogThreeInfoComponent, DialogDataThreeResult>;

    abstract openEnSegundoProcesoDialog(): MatDialogRef<SegundoPlanoComponent, DialogResult>;

    abstract openUnaActividadSinCategoria(): MatDialogRef<OneActionComponent, DialogResult>;

    abstract openFechaVencida(): MatDialogRef<OneActionComponent, DialogResult>;

    abstract closeProcesoSegundoPlanoDialog(): void;

    abstract openMaximoSocios(): MatDialogRef<OneActionComponent, DialogResult>;

    abstract openValoresMCCDialog(): MatDialogRef<ValoresMCCComponent, DialogResult>;

    abstract openPendienteContactoEjecutivo(): MatDialogRef<DialogRoundedComponent, DialogResult> ;
    
    abstract openPendienteContactoEjecutivoBO(): MatDialogRef<DialogRoundedComponent, DialogResult> ;
}
